var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRFis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-298.000000, -47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(299.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark-copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4036802,48.7813491 C42.1304912,48.8795712 43.7838749,49.0856864 45.3638314,49.3996949 L46.659242,53.4244385 L46.734,49.703 L47.3333333,49.8571429 C48.8984015,50.4320658 50.4634696,50.7900743 52.0285377,50.9311682 L50.3535572,59 L43.6339761,59 Z M34.939538,48.8241704 L31.8819814,59 L25.395113,59 L23.7951959,50.9894609 C25.5763633,50.9233214 27.2001869,50.545882 28.6666667,49.8571429 C28.9007788,49.7945971 29.1366381,49.7346186 29.3742445,49.6772074 L29.5839428,53.4244385 L30.6979319,49.3874821 C32.0575563,49.1200055 33.471425,48.9322349 34.939538,48.8241704 Z M22.9574468,17 L29.0333348,45.0771841 C28.9099809,45.1450321 28.7877582,45.2145421 28.6666667,45.2857143 C26.918562,46.047619 25.1037472,46.4285714 23.2222222,46.4285714 C23.109344,46.4285714 22.9957727,46.4272003 22.8815084,46.4244581 L17,17 L22.9574468,17 Z M52.1489362,17 L59,17.328125 L52.9667915,46.4156041 C51.2959408,46.3430913 49.4181214,45.9664614 47.3333333,45.2857143 C47.2904205,45.2604921 47.2473657,45.2354786 47.2041688,45.2106739 L52.1489362,17 Z M39.5905918,31.2503662 L43.5469673,43.6992994 C42.0329685,43.281738 40.3917066,43.0511754 38.6231817,43.0076116 L37.6125332,39.3253174 L36.6277662,43.0376694 C35.0913252,43.1236294 33.6550062,43.3567073 32.3188091,43.7369031 L36.012633,31.2503662 L39.5905918,31.2503662 Z",
    id: "Combined-Shape-Copy",
    fill: "url(#linearGradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,10 C18.0898509,10 21,12.9101491 21,16.5 C21,20.0898509 18.0898509,23 14.5,23 C10.9101491,23 8,20.0898509 8,16.5 C8,12.9101491 10.9101491,10 14.5,10 Z M14.7653759,13 L13,13 L13,21 L14.7653759,21 L14.7653759,17.6926677 C14.7653759,16.4945398 16.428246,15.1466459 17.8063781,15.1466459 L18,15.1466459 L18,13.2121685 L17.8063781,13.2121685 C16.5990888,13.2121685 15.3120729,13.7113885 14.7653759,14.6848674 L14.7653759,13 Z",
    id: "Combined-Shape-Copy-4",
    fill: "#00F3AB"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRFis);
export default __webpack_public_path__ + "static/media/rFIS.1ff649f5ae2a0c29653274e9ceae4211.svg";
export { ForwardRef as ReactComponent };